export const scrollToTop = () => {
    const scrollableDiv = document.getElementById('home-layout');
    if (!!scrollableDiv) {
      scrollableDiv.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    }
  };